export const InformationIcon = ({scale = 1, fill = "#797979"}: {scale?: number; fill?: string}) => {
  return (
    <svg
      style={{scale: `${scale}`, cursor: "pointer"}}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 22C13.9174 22 16.7153 20.8411 18.7782 18.7782C20.8411 16.7153 22 13.9174 22 11C22 8.08262 20.8411 5.28473 18.7782 3.22183C16.7153 1.15893 13.9174 0 11 0C8.08262 0 5.28473 1.15893 3.22183 3.22183C1.15893 5.28473 0 8.08262 0 11C0 13.9174 1.15893 16.7153 3.22183 18.7782C5.28473 20.8411 8.08262 22 11 22ZM9.28125 14.4375H10.3125V11.6875H9.28125C8.70977 11.6875 8.25 11.2277 8.25 10.6562C8.25 10.0848 8.70977 9.625 9.28125 9.625H11.3438C11.9152 9.625 12.375 10.0848 12.375 10.6562V14.4375H12.7188C13.2902 14.4375 13.75 14.8973 13.75 15.4688C13.75 16.0402 13.2902 16.5 12.7188 16.5H9.28125C8.70977 16.5 8.25 16.0402 8.25 15.4688C8.25 14.8973 8.70977 14.4375 9.28125 14.4375ZM11 5.5C11.3647 5.5 11.7144 5.64487 11.9723 5.90273C12.2301 6.16059 12.375 6.51033 12.375 6.875C12.375 7.23967 12.2301 7.58941 11.9723 7.84727C11.7144 8.10513 11.3647 8.25 11 8.25C10.6353 8.25 10.2856 8.10513 10.0277 7.84727C9.76987 7.58941 9.625 7.23967 9.625 6.875C9.625 6.51033 9.76987 6.16059 10.0277 5.90273C10.2856 5.64487 10.6353 5.5 11 5.5Z"
        fill={fill}
      />
    </svg>
  );
};
